import { ChangeDetectionStrategy, Component, forwardRef, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SelectButtonModule } from 'primeng/selectbutton';

import { setControlEnabled } from '../../../common/form/set-control-enabled';
import { FormGroupControlValueAccessor } from '../../generic/abstract-classes/form-group-control-value-accessor';
import { EventRequestDecisionResult } from '../common/event-request-decision-result';

@UntilDestroy()
@Component({
  selector: 'app-event-request-decision',
  standalone: true,
  imports: [FormsModule, InputTextareaModule, ReactiveFormsModule, SelectButtonModule, TranslocoModule],
  templateUrl: './event-request-decision.component.html',
  styleUrls: ['./event-request-decision.component.css'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => EventRequestDecisionComponent), multi: true }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventRequestDecisionComponent
  extends FormGroupControlValueAccessor<EventRequestDecisionResult, EventRequestDecisionResult>
  implements OnInit
{
  private trackValueChanges(): void {
    this.decision.valueChanges.pipe(untilDestroyed(this)).subscribe((decision) => {
      setControlEnabled(this.form.get('comment'), !!decision);
    });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Form Controls
  ///////////////////////////////////////////////////////////////////////////////////////////

  public get decision(): AbstractControl {
    return this.form.get('decision');
  }

  public get comment(): AbstractControl {
    return this.form.get('comment');
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  ///////////////////////////////////////////////////////////////////////////////////////////

  public override ngOnInit(): void {
    super.ngOnInit();

    this.trackValueChanges();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  ///////////////////////////////////////////////////////////////////////////////////////////

  public defineForm(): void {
    this.form = new UntypedFormGroup({
      comment: new UntypedFormControl({ value: undefined, disabled: true }),
      decision: new UntypedFormControl(undefined),
    });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Parse Value Change
  /////////////////////////////////////////////////////////////////////////////////////////////

  public parseValueChange(value: EventRequestDecisionResult): EventRequestDecisionResult {
    return value;
  }
}
